import React from 'react'
import Topheader from '../Topheader_Admin/Topheader_Admin'
import FooterAdmin from '../Footer_Admin/Footer_Admin'
import { Container, Box } from '@mui/material'
import classes from './MainTemplate_Admin.module.css'

const MainTemplateAdmin = (props) => {
    return (
        <>
            <Topheader />
            {/* No cap here: AdminPage decides how wide a screen may be. This was maxWidth="xl",
                MUI's 1536px, which silently overrode AdminPage — so neither the 1800 measure nor a
                table screen's full width ever took effect. */}
            <Container maxWidth={false} className={`${classes.contentContainer}`}>
                <Box className={`${classes.tableContent}`}>
                    {props.content}
                </Box>
                {/* <Footer college={'Kewdale'}/> */}
                <FooterAdmin  />
            </Container>
        </>
    )
}

export default MainTemplateAdmin